export enum Role {
  Admin = "ROLE_MANAGER",
  CaseManager = "CaseManager",
  Enfermera = "Enfermera",
  User = "User",
}
